import React, { useEffect, useState } from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';
import { useAPICall } from '../../hooks/useAPICall.js';

import { useNavigate } from 'react-router-dom';

import 'react-datepicker/dist/react-datepicker.css';
import { PageMenuElement } from '../elements/page_menu.js';


export function ReportMembershipSummaryForm() {


    const [pageData, setPageData] = useState();
   const [reportData, setReportData] = useState([]);
    
    const navigate = useNavigate();
    

    const { MakeCall } = useAPICall();


    const handleDataFetch = (data) => {
        setPageData(data);
        setReportData(data.components['report_data'].member_types);


    }
    useEffect(() => {
        MakeCall('reports/getmembershipsummaryreportdata', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleDataFetch);
    });


 
    function handleNav(destination, state) {
        navigate(destination, state);
    }
   

   

    function onPageMenuClick(onclickname) {
        switch (onclickname) {
            case 'goback':
                handleNav("/AdminReports");
                break;
           
            default:
                break;
        }
    }


    return (

        <div>

            {SecurityElement(pageData)}
            {MenuForm()}
            
            <div className="contentdiv">
            {PageMenuElement("Reports", [{ "name": "Back", "onclick": "goback" }], onPageMenuClick)}
              
                <div className='formbox'>
                    <div className='formtitle'>Membership summary report</div>
                    <div className='formrow' key='reports' style={{"paddingBottom":"25px"}}>
                       This report shows the number of each type of membership which is currently active or pending.                                          
                    </div>                    
                    
                    {reportData.map((memberTypes) => (
                            <div className='gridrow' key={memberTypes.Key}>
                                <div className='gridcell' style={{ "width": "30%" }}>{memberTypes.Key}</div>
                                <div className='gridcell' style={{ "width": "30%" }}>{memberTypes.Value}</div>
                                
                            </div>
                        ))}
                    
                </div>

           
            </div>
        </div>


    );
}
